import { useStorage } from '@vueuse/core'

export function useInternalUser() {
  const internalUser = useStorage('internal-user', false)

  return {
    internalUser
  }
}
